// extracted by mini-css-extract-plugin
module.exports = {"container":"Location__container___3SH0y"};